import { combineReducers } from 'redux';
import active from './active-reducer';
import results from './results-reducer';
import suggestions from './suggestions-reducer';

const searchReducer = combineReducers({
  active,
  results,
  suggestions,
});

export default searchReducer;
